import * as React from 'react';
import { SettingsRenderer } from '../../SettingsProvider/SettingsRenderer';
import { SettingsPage } from '../../components/SettingsPage/SettingsPage';
import { SettingsCategory } from '../../config/SettingsCategory';
import { useSettingsPage } from '../../hooks/useSettingsPage';
import { CAMERA_SETTING_IDS, AUDIO_SETTING_IDS } from '../../config/SettingIds';
import { CameraSetting } from '../../customSettings/CameraSetting/CameraSetting';

interface SoundAndCameraSettingsPageProps {
	title: string;
	description?: string;
}

export const SoundAndCameraSettingsPage: React.FC<SoundAndCameraSettingsPageProps> = ({
	title,
}) => {
	const { settingsState, availableSettingIds, handleChangeBySettingId } = useSettingsPage(
		{ category: SettingsCategory.SoundAndCamera, revertOnError: true }
	);

	const renderSetting = (settingId: string) => {
		// Custom rendering for speaker and microphone settings
		if (
			settingId === AUDIO_SETTING_IDS.DEFAULT_SPEAKER ||
			settingId === AUDIO_SETTING_IDS.DEFAULT_MICROPHONE
		) {
			const state = settingsState[settingId];

			// If state is not loaded yet, return null
			if (!state) {
				return null;
			}

			return (
				<SettingsRenderer
					key={settingId}
					settingId={settingId}
					settingsState={settingsState}
					handleChange={handleChangeBySettingId}
				/>
			);
		}
		// Custom rendering for camera settings (includes background blur toggle)
		else if (settingId === CAMERA_SETTING_IDS.AVAILABLE_CAMERA) {
			return <CameraSetting key={settingId} />;
		}

		// Default rendering for other settings
		return (
			<SettingsRenderer
				key={settingId}
				settingId={settingId}
				settingsState={settingsState}
				handleChange={handleChangeBySettingId}
			/>
		);
	};

	return (
		<SettingsPage
			title={title}
			settings={
				<>
					{/* Dynamically render all available settings */}
					{availableSettingIds.map(renderSetting)}
				</>
			}
		/>
	);
};
